module.exports = __webpack_public_path__ + "img/noelcouple.d034aac5.svg";